import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import firebase from 'firebase';
import './styles/main.scss';
import App from './App';
import ContextProvider from './contexts';
import { queryClient } from './query';
import reportWebVitals from './reportWebVitals';
console.log('env:', process.env);

if (!firebase.apps.length) {
	firebase.initializeApp({
		apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
		authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
	});
} else {
	firebase.app(); // if already initialized, use that one
}

ReactDOM.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>

			{/* 6LdqzusbAAAAAGbrfrVnPbWPtS6hCcEYn5kvBuyE */}
			<ContextProvider >
				<App />
			</ContextProvider>

		</QueryClientProvider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();